import { useState, useEffect } from 'react';

// mui
import { Stack, Typography, Tooltip } from '@mui/material';

import { Flag } from '../internal.js';

// client-shared
import { country as countryUtils } from '@goldblack/client-utils';

function getTimeOfDay(hour) {
    return hour >= 6 && hour < 18 ? { emoji: '☀️', label: 'Day' } : { emoji: '🌙', label: 'Night' };
}

function UserLocation({ country, timezone, showTime = false }) {
    const [now, setNow] = useState(new Date());

    useEffect(() => {
        if (!timezone || !showTime) return;

        let cancelled = false;

        function tick() {
            if (cancelled) return;
            setNow(new Date());

            const nextIn = 1000 - (Date.now() % 1000);
            setTimeout(tick, nextIn);
        }

        tick();

        return () => {
            cancelled = true;
        };
    }, [timezone, showTime]);

    let timeString = '';
    let fullTimeString = '';
    let timeOfDay = null;

    if (showTime && timezone) {
        const nowDate = new Date(now);

        fullTimeString = nowDate.toLocaleString(undefined, {
            timeZone: timezone,
            hour12: false,
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });

        timeString = nowDate.toLocaleTimeString(undefined, {
            timeZone: timezone,
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
        });

        const hour = parseInt(
            nowDate.toLocaleString('en-US', {
                timeZone: timezone,
                hour: '2-digit',
                hour12: false,
            }),
            10,
        );
        timeOfDay = getTimeOfDay(hour);
    }

    return (
        <Stack direction='row' alignItems='center' gap={0}>
            {country && (
                <Tooltip title={countryUtils.getCountryName(country)}>
                    {Flag(country, country.toLowerCase(), { ml: 1, mt: 0 })}
                </Tooltip>
            )}
            {showTime && timezone && timeOfDay && (
                <>
                    <Tooltip title={timeOfDay.label}>
                        <Typography sx={{ fontSize: '13px', ml: 1, lineHeight: 1, cursor: 'default' }}>
                            {timeOfDay.emoji}
                        </Typography>
                    </Tooltip>
                    <Tooltip title={fullTimeString}>
                        <Typography
                            color='primary.main'
                            sx={{
                                fontWeight: 'bold',
                                fontFamily: 'sans-serif',
                                fontSize: '12px',
                                ml: 0.5,
                                mt: 0,
                            }}>
                            {timeString}
                        </Typography>
                    </Tooltip>
                </>
            )}
        </Stack>
    );
}

export { UserLocation };
